import axios from "axios"

export default axios.create({
    // baseURL:"http://localhost:7600"
    baseURL:"https://gray-sturgeon-veil.cyclic.app"
})